import React, {
  ReactNode,
  createContext,
  useContext,
  useState,
  useCallback,
} from 'react'

interface HoveredItemContextValue {
  hovered: any
  getElementProps: (item: any) => {
    onMouseEnter: () => void
    onMouseLeave: () => void
  }
}

interface HoveredItemProviderProps {
  children: ReactNode
}

const HoveredItemContext = createContext<HoveredItemContextValue | null>(null)

const useHoveredItem = () => {
  const value = useContext(HoveredItemContext)

  if (!value) {
    throw new Error('useHoveredItem must be used within a HoveredItemProvider')
  }

  return value
}

export const HoveredItemProvider = (props: HoveredItemProviderProps) => {
  const [hovered, setHovered] = useState<any>(null)

  const getElementProps = useCallback(
    (item: any) => ({
      onMouseEnter: () => setHovered(item),
      onMouseLeave: () => setHovered(null),
    }),
    []
  )

  return (
    <HoveredItemContext.Provider
      {...props}
      value={{ hovered, getElementProps }}
    />
  )
}

export default useHoveredItem
